import React, { useEffect, useRef, useState } from 'react';
import { ControlBarWrapper, CustomControlButtonList, CustomControlWrapper } from '../../Player/styles';
import VastPlayControls from './VastPlayControls';
import RemindDuration from './RemindDuration';
import TitleBar from './TitleBar';
import Watermark from './Watermark';
import ControlBarVolumeController from './ControlBarVolumeController';
import { Flex } from '../../../styles';
import VastControlBarProgress from './VastControlBarProgress';

export default function PlayerVastComponents({ player, vastRef, isShort }: {
  player: HTMLVideoElement;
  vastRef: React.RefObject<any>;
  isShort: boolean;
}) {
  const [showPlayBtn, setShowPlayBtn] = useState<boolean>(true);
  const timer = useRef<any>();

  useEffect(() => {
    const playerWrapper = document.getElementById('custom-player-wrapper');
    if (playerWrapper) playerWrapper.style.cursor = 'default';

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchmove', handleMouseMove);
    document.addEventListener('keydown', handleMouseMove);

    return () => {
      clearTimeout(timer.current);
      timer.current = null;
      const wrapper = document.getElementById('custom-player-wrapper');
      if (wrapper) wrapper.style.cursor = 'default';
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('keydown', handleMouseMove);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  const handleMouseMove = () => {
    const playerWrapper = document.getElementById('custom-player-wrapper');
    if (playerWrapper) playerWrapper.style.cursor = 'default';
    setShowPlayBtn(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      const wrapper = document.getElementById('custom-player-wrapper');
      if (wrapper) wrapper.style.cursor = 'none';
      setShowPlayBtn(false);
    }, 2000);
  };

  // adVideo is created by SimpleVast before vast.play fires (which triggers this component to mount)
  const adVideo = vastRef.current?.adVideo as HTMLVideoElement | null;

  // No z-index on the wrapper: that would make it a stacking context, and a full-size one over
  // the whole player swallows the taps meant for the layers its children are stacked against -
  // the unmute click zone among them. The children carry their own layers instead.
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
      {!showPlayBtn && <Watermark />}
      <CustomControlWrapper show={true}>
        {adVideo && <RemindDuration player={adVideo} />}
        <VastPlayControls vastRef={vastRef} showPlayBtn={showPlayBtn} />
        {showPlayBtn && !isShort && <TitleBar />}
        <ControlBarWrapper>
          <VastControlBarProgress player={player} />
          <CustomControlButtonList>
            <Flex>
              {/* Volume is controlled on the content element even during an ad: SimpleVast
                  mirrors it onto the ad overlay, so the level and mute carry across the break
                  in both directions (video.js gets this for free by swapping the ad source on
                  the one player). */}
              <ControlBarVolumeController player={player} />
            </Flex>
          </CustomControlButtonList>
        </ControlBarWrapper>
      </CustomControlWrapper>
    </div>
  );
}
